import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";

export const createCmsGraphQLClient = (apiUrl: string) => {
    const httpLink = new HttpLink({
        uri: `${apiUrl}/graphql`,
        headers: {
            ...(process.env.STRAPI_API_TOKEN
                ? {
                      Authorization: `Bearer ${process.env.STRAPI_API_TOKEN}`,
                  }
                : {}),
        },
    });

    return new ApolloClient({
        link: httpLink,
        // Default query policy is no-cache; nothing is normalized into cache, so custom
        // typePolicies (e.g. PageEntity.attributes merge) would never run. Re-add if you
        // switch back to cache-first and a long-lived client.
        cache: new InMemoryCache(),
        defaultOptions: {
            query: {
                fetchPolicy: "no-cache",
                // "none": GraphQL errors reject the query promise (fail CI/build when CMS errors).
                // "all" mixes errors + partial data and often hides failures until empty-state bugs appear.
                errorPolicy: "none",
            },
        },
    });
};
